const ViewPODButtonRenderer = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        props.onClickViewPOD(props);  // Call the passed onClickViewPOD function
    };

    return (
        <button
            onClick={handleClick}
            className="btn btn-success"
            style={{ padding: "2px 10px", fontSize: "13px", margin: "0" }}
            title="View POD"
            // disabled={props.isSubmitted != 1}  // Disable if not submitted
        >
            View POD
        </button>
    );
};

export default ViewPODButtonRenderer;
